import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { BarrierProfile } from '../entities/barrier-profile';

/**
 * Base url for api
 */
const BASE_URL = 'barrier-profiles';

@Injectable({
  providedIn: 'root',
})

/**
 * Barrier Profile Service
 */
export class BarrierProfileService {
  /**
   * Is loading
   */
  public loading$: Observable<boolean>;

  /**
   * Constructor
   *
   * @param apiService ApiService
   * @param httpClient HttpClient
   * @param authenticationService AuthenticationService
   */
  constructor(private apiService: ApiService) {
    this.loading$ = this.apiService.loading$;
  }

  /**
   * list
   *
   */
  list(): Observable<BarrierProfile[]> {
    return this.apiService
      .get(`${BASE_URL}/list`)
      .pipe(map((barrierProfiles) => barrierProfiles.map((barrierProfile) => BarrierProfile.createFromJson(barrierProfile))));
  }
}
